<template>
    <div>{{ date }}</div>
</template>


<script>
import moment from "moment";

export default {
    name: "date-action-result",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    computed: {
        date() {
            return this.action.date === null
                ? "..."
                : moment(this.action.date, "YYYY-MM-DDTHH:mm:ss").format(
                      "DD/MM/yyyy"
                  );
        },
    },
};
</script>